import React from 'react';

import { Grid, Typography, makeStyles, useTheme } from '@material-ui/core';
import AutoCard from 'components/AutoCard';
import FilterSelector from 'components/FilterSelector';
import i18n from 'i18n';
import {
  PartnerEnvironmentsCostGraphFields,
  PeriodCountAccess,
} from 'modules/dashboard/interfaces';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import {
  getPartnerEnvironmentsCostGraphRequest,
  setPartnerEnvironmentsCostPeriodFilter,
} from 'modules/dashboard/actions';
import { formatCurrency } from 'utils/helpers';
import { filterPeriodOptions } from 'utils/graphs';
import { CompanyData, PartnerData } from 'modules/authenticate/interfaces';
import styles, { overrideCardGraph, overrideFilter } from './styles';
import EnvironmentsCostPartnerGraphContent from './EnvironmentsCostPartnerGraphContent';

interface EnvironmentsCostPartnerCardProps {
  companySelected: CompanyData | null;
  partnerSelected: PartnerData | null;
  partnerEnvironmentsCostGraphFields: PartnerEnvironmentsCostGraphFields;
  intervalTime: PeriodCountAccess;
  setPartnerEnvironmentsCostPeriodFilter: (prop: string) => void;
  getPartnerEnvironmentsCostGraphRequest: ({
    companyUuid,
    partnerUuid,
    intervalTime,
  }) => void;
}

const EnvironmentsCostPartnerCard = ({
  companySelected,
  partnerSelected,
  partnerEnvironmentsCostGraphFields,
  intervalTime,
  setPartnerEnvironmentsCostPeriodFilter,
  getPartnerEnvironmentsCostGraphRequest,
}: EnvironmentsCostPartnerCardProps) => {
  const useStyles = makeStyles(styles);
  const classes = useStyles({});
  const { breakpoints } = useTheme();

  React.useEffect(() => {
    if (companySelected && partnerSelected) {
      getPartnerEnvironmentsCostGraphRequest({
        companyUuid: companySelected.id,
        partnerUuid: partnerSelected.id,
        intervalTime,
      });
    }
  }, [
    companySelected,
    partnerSelected,
    intervalTime,
    getPartnerEnvironmentsCostGraphRequest,
  ]);

  return (
    <Grid
      item
      xs={6}
      justify="center"
      alignContent="center"
      className={classes.pageBody}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} className={classes.graphCard}>
          <Grid container alignItems="center" justify="space-between">
            <Grid item>
              <Typography className={classes.titleCard}>
                {i18n.t('COSTS_PAGE.ENVIRONMENTS_COST_TITLE_KEY')}
                {': '}
                {formatCurrency(partnerEnvironmentsCostGraphFields.total)}
              </Typography>
            </Grid>
            <Grid item>
              <FilterSelector
                overrideClasses={overrideFilter}
                options={filterPeriodOptions(
                  setPartnerEnvironmentsCostPeriodFilter
                )}
                currentValue={{
                  label: i18n.t(
                    `ENVIRONMENT_DASHBOARD.LAST_${intervalTime.toUpperCase()}`
                  ),
                  onClick: () => null,
                }}
              />
            </Grid>
          </Grid>
          <AutoCard overrideClasses={overrideCardGraph(breakpoints)}>
            <Grid container className={classes.containerGraph}>
              <EnvironmentsCostPartnerGraphContent />
            </Grid>
          </AutoCard>
        </Grid>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({
  authenticate: { companySelected, partnerSelected },
  dashboard: {
    partnerEnvironmentsCostGraphFields,
    partnerEnvironmentsCostPeriodFilter,
  },
}: ApplicationState) => ({
  companySelected,
  partnerSelected,
  partnerEnvironmentsCostGraphFields,
  intervalTime: partnerEnvironmentsCostPeriodFilter,
});

export default connect(mapStateToProps, {
  setPartnerEnvironmentsCostPeriodFilter,
  getPartnerEnvironmentsCostGraphRequest,
})(EnvironmentsCostPartnerCard);
